// Apply one mode to the entire POS only at a safe UI boundary.
export const orderingModeMethods = {
    async refreshOrderingMode(){
      const request=++this.modeRequest;
      try {
        const {data}=await this.fetchOrderingMode();
        if(request!==this.modeRequest)return;
        this.pendingMode=!!data.ordering;
        this.applyPendingMode();
      } catch(error){if(request===this.modeRequest)this.modeMessage='Terminal mode could not be refreshed. Current mode is unchanged; retry REFRESH.';}
    },
    applyPendingMode(){
      if(this.pendingMode===null)return;
      if(this.pendingMode===this.orderingMode){this.pendingMode=null;this.modeMessage='';return;}
      if(this.selectedOrder || this.modalOpened || this.modeDialogOpen?.()){this.modeMessage='Terminal mode changed in Admin. Close or cancel the current dialog, then return to orders to apply; saved orders are retained.';return;}
      this.orderingMode=this.pendingMode;this.pendingMode=null;this.modeMessage='';
      this.serviceView='order';this.orderingContext={seat:1,round:1};this.ordersOpen=this.orderingMode;
    },
};
